const PAID_RESTART_MESSAGES = {
  pageTitle: 'dashboard.subscriptionRestart.header.title',
  heading: 'dashboard.subscriptionRestart.confirm.heading',
  intro: 'dashboard.subscriptionRestart.confirm.intro',
  nextPaymentLabel: 'dashboard.subscriptionRestart.confirm.nextPaymentLabel',
  nextPaymentCopy: 'dashboard.subscriptionRestart.confirm.nextPaymentCopy',
  consentCheckboxLabel: 'dashboard.subscriptionRestart.confirm.consentCheckboxLabel',
  consentDisclaimer: 'dashboard.subscriptionRestart.confirm.consentDisclaimer',
  submitButton: 'dashboard.subscriptionRestart.confirm.submitButton',
  submittingAriaLabel: 'dashboard.subscriptionRestart.confirm.submitting.ariaLabel',
};

const TRIAL_RESUME_MESSAGES = {
  pageTitle: 'dashboard.subscriptionRestart.trial.header.title',
  heading: 'dashboard.subscriptionRestart.trial.confirm.heading',
  intro: 'dashboard.subscriptionRestart.trial.confirm.intro',
  nextPaymentLabel: 'dashboard.subscriptionRestart.confirm.nextPaymentLabel',
  nextPaymentCopy: 'dashboard.subscriptionRestart.confirm.nextPaymentCopy',
  consentCheckboxLabel: 'dashboard.subscriptionRestart.trial.confirm.consentCheckboxLabel',
  consentDisclaimer: 'dashboard.subscriptionRestart.trial.confirm.consentDisclaimer',
  submitButton: 'dashboard.subscriptionRestart.trial.confirm.submitButton',
  submittingAriaLabel: 'dashboard.subscriptionRestart.trial.confirm.submitting.ariaLabel',
};

export function getRestartMessages(inTrial) {
  return inTrial ? TRIAL_RESUME_MESSAGES : PAID_RESTART_MESSAGES;
}
